<template>
  <div>
    <div>
      <SelectClient
        class="mt-n4"
        @client-selected="getSelectedClient"
        @new-client-created="getSelectedClient"
      ></SelectClient>
    </div>

    <SelectService
      @service-selected="addItemToSelection"
      class="mt-4"
    ></SelectService>
    <SelectProduct
      class="mt-4"
      @product-selected="addItemToSelection"
    ></SelectProduct>

    <SelectTransport
      class="mt-4"
      @transportation-selected="addItemToSelection"
    ></SelectTransport>
    <DatesCommentsAndDiscounts
      class="mt-4"
      v-if="selectedClient"
      @date-selected="getSelectedDate"
      @get-discount-amount="getDiscountAmount"
      @get-comment="getComment"
    >
    </DatesCommentsAndDiscounts>
  </div>
</template>

<script>
import SelectClient from "@/components/Clients/SelectClient.vue";
import SelectService from "./SelectService.vue";
import SelectProduct from "./SelectProduct.vue";
import SelectTransport from "./SelectTransport.vue";
import DatesCommentsAndDiscounts from "./DatesCommentsAndDiscounts.vue";
export default {
  components: {
    SelectService,
    SelectClient,
    SelectProduct,
    SelectTransport,
    DatesCommentsAndDiscounts,
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  data: () => ({
    selectedClient: null,
  }),
  methods: {
    getSelectedClient(client) {
      this.selectedClient = client;
      this.$emit("client-selected", client);
    },
    addItemToSelection(item) {
      this.$emit("item-selected", item);
    },
    getSelectedDate(selectedDate) {
      this.$emit("date-selected", selectedDate);
    },
    getDiscountAmount(discountAmount) {
      this.$emit("get-discount-amount", discountAmount);
    },
    getComment(comment) {
      this.$emit("get-comment", comment);
    },
  },
};
</script>
